/*----------------------------------
- SALES PAGE: WEBSITE LINKS
----------------------------------*/

/**
 * @docs docs/features/sales-page
 * @adr  ADR-0067
 * @rule A visitor's links stay public: an ending opens its published TLD page or the hub, a word
 *       its public search. A row and the lanes are walls (the page cancels their navigation), so
 *       their href only says where a member would go.
 */

import { TLD_HUB_PATH } from '@uniquedomains/components/contracts/tlds/public';
import type { SalesPageHrefs } from '@uniquedomains/components/sales/salesTypes';

import { encodeRadarFiltersUrl } from '@/common/libs/filters';
import { resolvePublishedTldHref } from '@/client/pages/landing/tld/lib/presentation';

/*----------------------------------
- PUBLIC API
----------------------------------*/

const buildWordSearchHref = (word: string): string => encodeRadarFiltersUrl({ prompt: word }, { surface: 'website' });

export const buildSalesWebsiteHrefs = (publishedPaths: ReadonlySet<string> | null): SalesPageHrefs => ({
    row: (row) => buildWordSearchHref(row.label),
    ending: (ending) => resolvePublishedTldHref(ending, publishedPaths) ?? TLD_HUB_PATH,
    word: buildWordSearchHref,
    nearRow: () => '#near',
    soldBeforeRow: () => '#sold-before',
    nearLane: '#near',
    soldBeforeLane: '#sold-before',
});
